
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from '@/components/ui/card';
import { CheckIcon } from 'lucide-react';
import { IMAGE_PATHS } from '@/utils/imagePaths';
import { RemoteImage } from '@/components/common/ResponsiveImage';
import { supabaseImgSrc, supabaseSrcSet } from '@/lib/images';

export const BeforeAfterShowcase = () => {
  return (
    <Card className="bg-white shadow-md mb-12">
      <CardHeader className="pb-2">
        <CardTitle className="text-center">Quality Electrical Work You Can Trust</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <div className="relative h-64 overflow-hidden rounded-md border border-gray-200">
              <RemoteImage
                src={supabaseImgSrc(IMAGE_PATHS["19fa238c-a2ce-4705-b475-8d43342ae1b6.jpg"], { width: 960, format: "webp" })}
                srcSet={supabaseSrcSet(IMAGE_PATHS["19fa238c-a2ce-4705-b475-8d43342ae1b6.jpg"], [320, 640, 960], "webp")}
                sizes="(max-width: 768px) 100vw, 50vw"
                width={960}
                height={640}
                alt="Before: Obsolete outdated electrical panel with old circuit breakers and safety concerns before professional upgrade by Elevation Electrical, LLC in Central Florida"
                className="object-cover w-full h-full"
              />
              <div className="absolute top-2 left-2 bg-navy/90 text-white px-3 py-1 rounded-full text-sm font-medium">
                Before
              </div>
            </div>
            <p className="text-sm text-gray-600 text-center">Outdated electrical panel with safety concerns</p>
          </div>
          
          <div className="space-y-2">
            <div className="relative h-64 overflow-hidden rounded-md border border-gray-200">
              <RemoteImage
                src={supabaseImgSrc(IMAGE_PATHS["5acf8b8d-05c4-4523-87fe-2dbb517e9ce0.jpg"], { width: 960, format: "webp" })}
                srcSet={supabaseSrcSet(IMAGE_PATHS["5acf8b8d-05c4-4523-87fe-2dbb517e9ce0.jpg"], [320, 640, 960], "webp")}
                sizes="(max-width: 768px) 100vw, 50vw"
                width={960}
                height={640}
                alt="After: Modern upgraded electrical panel with organized circuit breakers, enhanced safety features, and improved capacity installed by licensed Elevation Electrical contractors"
                className="object-cover w-full h-full"
              />
              <div className="absolute top-2 left-2 bg-orange text-navy px-3 py-1 rounded-full text-sm font-medium">
                After
              </div>
            </div>
            <p className="text-sm text-gray-600 text-center">Modern, upgraded panel with improved safety and capacity</p>
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex-col space-y-3 pt-2">
        <h4 className="font-semibold text-center w-full">Our Electrical Panel Upgrades Include:</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {["Increased capacity", "Enhanced safety", "Modern circuit breakers", "Improved organization", "Code compliance", "Reduced fire risk"].map((benefit) => (
            <div key={benefit} className="flex items-center space-x-2">
              <CheckIcon className="h-4 w-4 text-orange" />
              <span className="text-sm">{benefit}</span>
            </div>
          ))}
        </div>
      </CardFooter>
    </Card>
  );
};

export default BeforeAfterShowcase;
